<div *ngIf="checkIfHtmlSet()" [innerHTML]="innerHTML"></div>
